<template>
  <div class="d-flex flex-wrap">
    <div v-for="(tag, index) in tags" :key="index" class="d-flex">
      <Tag :text="tag" :small="small"/>
    </div>
  </div>
</template>

<script>
import Tag from "@/components/Tag";
export default {
  name: "TagList",
  components: {Tag},
  props:{
    tags:{
      type: Array,
      default: ()=>["Hallo", "Salut"]
    },
    small:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>